import { clearCsrfToken } from "@src/app/api/config/csrf";

export const clearLegacyAuthStorage = (): void => {
  localStorage.removeItem("insideFleet@user");
  sessionStorage.removeItem("insideFleet@token");
  sessionStorage.removeItem("insideFleet@expiration");
  sessionStorage.removeItem("insideFleet@refreshToken");
};

export const clearClientAuthState = (): void => {
  clearLegacyAuthStorage();
  clearCsrfToken();
};
